import { Field } from "formik";
import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next"; /* Added Line */
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListSelect from "../../components/list-fields/ListSelect";
import EditListComponent from "../../components/list/EditableListComponent";
import Filters from "../../components/list/Filters";
import Main from "../../components/main/Main";
import request from "../../services/request";
import { formatShortDate, getValueWithParameter, formatCompanyList } from "../../utils";
import DocumentUpdate from "../home/document-update/DocumentUpdate";
import { Button } from "react-bootstrap";

function EditExistingRecords() {
  const [configData, setConfigData] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [t] = useTranslation();
  const [refreshList, setRefreshList] = useState(false);
  const [filters, setFilters] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [closedStartDate, setClosedStartDate] = useState(null);
  const [closedEndDate, setClosedEndDate] = useState(null);

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };
  return (
    <Main>
      <div className="row">
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                  } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="mevcut-kayitlar/config"
                    configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="isSubsidiary"
                      label={t("demandList.istirakSirketleri")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.isSubsidiary}
                    />
                    <Field
                      name="sirketID"
                      label={t("davaIcraSavcilik.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.sirketler}
                    />
                    <Field
                      name="dosyaDurumId"
                      label={t("demandList.dosyaDurumu")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.dosyaDurum}
                    />
                    <Field
                      name="islemNo"
                      label={t("davaIcraSavcilik.islemNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="mahkemeNo"
                      label={t("davaIcraSavcilik.mahkemeNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="davaTuruID"
                      label={t("demandList.davaTuru")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.davaTurleri}
                    />
                    <Field
                      name="dosyaGrubu"
                      label={t("demandList.talepTuru")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepTurleri} // dosyaTurleri
                    />
                    <Field
                      name="konu"
                      label={t("davaIcraSavcilik.konu")}
                      colNumber="3"
                      component={TextInput}
                    />
                    {/* <Field
                      name="avukatKodu"
                      label={t("demandList.avukatKodu")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    <Field
                      name="davali"
                      label={t("demandCreate.davali")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="davaci"
                      label={t("demandCreate.davaci")}
                      colNumber="3"
                      component={TextInput}
                    />

                    <Field
                      name="durusmaTarihiMin"
                      label={t("report.durusmaTarihiMin")}
                      colNumber="3"
                      component={ReactDatePicker}
                    />
                    <Field
                      name="durusmaTarihiMax"
                      label={t("report.durusmaTarihiMax")}
                      colNumber="3"
                      component={ReactDatePicker}
                    />
                    <Field
                      name="acilisTarihiMin"
                      label={t("report.talepatbas")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => { setStartDate(date) }}
                      maxDate={endDate}
                    />
                    <Field
                      name="acilisTarihiMax"
                      label={t("report.talepatbts")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => { setEndDate(date) }}
                      minDate={startDate}
                    />
                    <Field
                      name="kapanisTarihiMin"
                      label={t("report.talepktbas")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => { setClosedStartDate(date) }}
                      maxDate={closedEndDate}
                    />
                    <Field
                      name="kapanisTarihiMax"
                      label={t("report.talepktbts")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => { setClosedEndDate(date) }}
                      minDate={closedStartDate}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <DocumentUpdate
            title={"Tamamlananlar"}
            endpoint={"dosya/guncelle"}
            okButtonText={"Kaydet"}
            refreshList={refreshList}
            setRefreshList={setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <EditListComponent
            entityName=""
            endpoint="talep-girisi/listele-mevcutkayitlar"
            keyField="id"
            refreshList={refreshList}
            hideSelection
            customBody={{
              filters: filters,
            }}
            // mapNativeDataBeforeList={(data) => { return data.map(item => { const { dosyaDurumId, ...others } = item; return others; }) }}
            columns={[
              {
                dataField: "id",
                text: `${t("demandList.islemNo")}`,
                sort: true,
                editable: false,
                headerStyle: {
                  width: 64
                }
              },
              {
                dataField: "dosya.dosyaNo",
                text: t("demandCreate.dosyaNo"),
                sort: true,
                editable: true,
                headerStyle: {
                  width: 64
                }
              },
              {
                dataField: "company",
                text: `${t("demandList.grupSirketi")}`,
                sort: true,
                formatter: (data) => getValueWithParameter(data, "name"),
                editorRenderer: (editorProps, value) => (
                  <ListSelect
                    {...editorProps}
                    value={value}
                    name="test"
                    options={
                      configData &&
                      configData.sirketler.map((s) => {
                        return {
                          id: s.value,
                          name: s.label,
                          ...s,
                        };
                      })
                    }
                  />
                ),
              },
              {
                dataField: "taraf1",
                text: `${t("demandList.davaci")}`,
                sort: true,
                formatter: (cell, row) => formatCompanyList(row, "taraf1", "tarafCompanyList"),
              },
              {
                dataField: "davali",
                text: `${t("demandList.davali")}`,
                sort: true,
                formatter: (cell, row) => formatCompanyList(row, "davali", "davaliCompanyList"),
              },
              {
                dataField: "gnlTpDavaTuru",
                text: `${t("demandList.davaTuru")}`,
                sort: true,
                formatter: (data) => getValueWithParameter(data, "name"),
                editorRenderer: (editorProps, value) => (
                  <ListSelect
                    {...editorProps}
                    value={value}
                    name="test"
                    options={
                      configData &&
                      configData.davaTurleri.map((s) => {
                        return {
                          id: s.value,
                          name: s.label,
                          ...s,
                        };
                      })
                    }
                  />
                ),
              },
              {
                dataField: "gnlTpIlkDavaTuru",
                text: `${t("demandList.davaTuru1")}`,
                sort: true,
                formatter: (data) => getValueWithParameter(data, "name"),
                editorRenderer: (editorProps, value) => (
                  <ListSelect
                    {...editorProps}
                    value={value}
                    name="test"
                    options={
                      configData &&
                      configData.ilkDavaTurleri.map((s) => {
                        return {
                          id: s.value,
                          name: s.label,
                          ...s,
                        };
                      })
                    }
                  />
                ),
              },
              {
                dataField: "gnlTpIkinciDavaTuru",
                text: `${t("demandList.davaTuru2")}`,
                sort: true,
                formatter: (data) => getValueWithParameter(data, "name"),
                editorRenderer: (editorProps, value) => (
                  <ListSelect
                    {...editorProps}
                    value={value}
                    name="test"
                    options={
                      configData &&
                      configData.ikinciDavaTurleri.map((s) => {
                        return {
                          id: s.value,
                          name: s.label,
                          ...s,
                        };
                      })
                    }
                  />
                ),
              },
              {
                dataField: "konu",
                text: `${t("demandList.konu")}`,
                sort: true,
                editable: true,
              },
              {
                dataField: "daireNo",
                text: `${t("davaIcraSavcilik.mahkemeNo")}`,
                sort: true,
              },
              {
                dataField: "icraNo",
                text: `${t("davaIcraSavcilik.icraNo")}`,
                sort: true,
              },
              {
                dataField: "davaTarihi",
                text: t("demandCreate.durusmaTarihi"),
                sort: true,
                formatter: formatShortDate,
                editable: false,
                headerStyle: {
                  width: 80
                }
              },
              {
                dataField: "dosyaDurum",
                formatter: (data) => getValueWithParameter(data, "dosyaDurum"),
                text: `${t("demandList.dosyaDurumu")}`,
                editorRenderer: (editorProps, value) => (
                  <ListSelect
                    {...editorProps}
                    value={value}
                    name="test"
                    options={
                      configData &&
                      configData.dosyaDurum.map((s) => {
                        return {
                          id: s.value,
                          dosyaDurum: s.label,
                          ...s,
                        };
                      })
                    }
                  />
                ),
              },
              {
                dataField: "avukat",
                text: `${t("demandList.avukat")}`,
                sort: true,
                formatter: (data) => getValueWithParameter(data, "fullName"),
                editorRenderer: (editorProps, value) => (
                  <ListSelect
                    {...editorProps}
                    value={value}
                    name="test"
                    options={
                      configData &&
                      configData.users.map((s) => {
                        return {
                          id: s.value,
                          fullName: s.label,
                          ...s,
                        };
                      })
                    }
                  />
                ),
              },
              /*{
                dataField: "gorevlendirilenDisAvukat.avukatKod",
                text: t("demandList.disKod"),
                sort: true,
                editable: false,
                headerStyle: {
                  width: 80
                }
              },*/
              {
                dataField: "gorevlendirilenDisAvukat",
                text: t("demandUpdate.gorevlendirilenDisAvukat"),
                sort: true,
                formatter: (data) => getValueWithParameter(data, "fullName"),
                editorRenderer: (editorProps, value) => (
                  <ListSelect
                    {...editorProps}
                    value={value}
                    name="test"
                    options={
                      configData &&
                      configData.disAvukatlar.map((s) => {
                        return {
                          id: s.value,
                          fullName: s.label,
                          ...s,
                        };
                      })
                    }
                  />
                ),
              },
              {
                dataField: "test",
                text: t('actionButtons.islemler'),
                sort: false,
                editable: false,
                formatter: (cell, row) => {
                  return (
                    <Button
                      className={"btn-xs"}
                      variant="outline-warning"
                      onClick={() => onUpdateButtonClicked(row)}
                    >
                      {t('actionButtonGenerator.guncelle')}
                    </Button>
                  );
                },
              },
            ]}
            actionButtonsObject={{
              actions: [
                requestTo(ABT.EXCEL_EXPORT, "file/download-excel-mevcut-kayitlar"),
                requestTo(ABT.UPDATE_ALL_ITEM, "talep-girisi/update-list"),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}

export default EditExistingRecords;
